<template>
  <div class="list-content d-flex">
    <div
      class="article-wrapper create-wrapper"
      v-if="!$isCallCenter && currentTab === 'draft'"
    >
      <router-link
        :to="{ name: 'ArticleCreate' }"
        tag="button"
        class="btn btn-sc-create-article"
      >
        <img src="/static/icons/article-create-plus.svg" class="" />
        <span>{{ $t("label.create") }}</span>
      </router-link>
    </div>
    <div class="article-wrapper content-wrapper">
      <ul>
        <li
          class="news media"
          v-for="(article, index) in articles"
          :key="index"
        >
          <div class="image-wrapper">
            <img :src="article.coverUrl" class="cover" />
          </div>
          <router-link
            :to="{
              name: 'ArticleDetail',
              params: { articleType: type, articleId: article.articlesId }
            }"
            tag="div"
            class="media-body news-content pointer"
          >
            <p class="news-title">
              {{
                article.title ? article.title : $t("feature.article.no_title")
              }}
            </p>
            <p class="news-detail">
              {{ article.content | article-content }}
            </p>
            <p class="news-footer">
              {{ $t("create_by") }}
              <strong
                >{{ article.createdBy.firstName }}
                {{ article.createdBy.lastName }}</strong
              >
            </p>
            <p class="no-thumbnail" v-if="!article.thumbnail">
              ไม่มี Thumbnail
            </p>
          </router-link>
          <div class="pl-3 d-flex flex-column text-right">
            <div class=" news-time">
              {{ checkTimeStage(article) }}
            </div>
            <div :class="publishTimeClass(article)" v-show="article.publishedAt">
              เวลาเริ่มประกาศข่าวนี้คือ {{ publishTime(article) }} น.
            </div>
            <div :class="expiredTimeClass(article)" v-show="article.expiredAt">
              เวลาสิ้นสุดข่าวนี้คือ {{ expiredTime(article) }} น.
            </div>
            <div class="mb-auto news-time">
              {{ checkActionStage(article) }}
            </div>
            <div class="mt-3 ml-auto pointer">
              <span
                class="article-list-button"
                v-if="showListAttendanceButton(article)"
              >
                <router-link
                  target="_blank"
                  :to="{
                    name: 'AttendanceList',
                    params: { articleType: type, articleId: article.articlesId }
                  }"
                >
                  {{ $t("button.see_attendances") }}
                </router-link>
              </span>
              <span
                class="article-list-button"
                @click="showDialog(true, article.articlesId)"
                v-if="!article.deletedAt && checkDeleteRole()"
              >
                <img src="/static/icons/trash.svg" :alt="$t('label.delete')" />
              </span>
            </div>
          </div>
        </li>
      </ul>
      <infinite-loading
        @infinite="infiniteHandler"
        spinner="spiral"
        ref="infiniteLoading"
      >
        <span slot="no-results">
          {{ $t("label.no_result") }}
        </span>
        <span slot="no-more"> </span>
      </infinite-loading>
    </div>
    <confirm
      v-show="dialogConfirm"
      @confirm="confirm"
      :data="deleteDialog"
    ></confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import InfiniteLoading from "vue-infinite-loading";
import { getCookie, Auth } from "@/lib/cookie";

export default {
  name: "list-content",
  props: ["currentTab", "currentSearchText"],
  components: {
    InfiniteLoading
  },
  data() {
    return {
      articles: [],
      count: 1,
      status: this.currentTab,
      searchText: this.currentSearchText,
      page: 0,
      limit: 5,
      deleteArticle: "",
      dialogConfirm: false,
      deleteDialog: {
        title: "",
        detail: "คุณแน่ใจหรือไม่ว่าต้องการลบข่าวนี้?",
        buttonCancel: "ยกเลิก",
        buttonSubmit: "ลบ"
      }
    };
  },
  watch: {
    currentSearchText(value) {
      this.searchText = value;
      this.resetLoading();
    },
    currentTab(value) {
      this.status = value;
    },
    $route() {
      this.resetLoading();
    }
  },
  computed: {
    type() {
      return this.$route.params.articleType;
    }
  },
  methods: {
    expiredTime(article) {
      return moment(article.expiredAt).format("D MMMM YYYY, H:mm:ss");
    },
    expiredTimeClass(article) {
      return {
        "news-time": true,
        "news-time-expired": moment(article.expiredAt) < moment()
      };
    },
    publishTime(article) {
      return moment(article.publishedAt).format("D MMMM YYYY, H:mm:ss");
    },
    publishTimeClass(article) {
      return {
        "news-time": true,
        "news-time-expired": moment(article.publishedAt) > moment()
      };
    },
    infiniteHandler($state) {
      this.getArticles(
        this.type,
        this.status,
        this.searchText,
        this.page + 1,
        $state || this.$refs.infiniteLoading.stateChanger
      );
      this.getArticlesStatus(this.type, this.searchText);
    },
    resetLoading() {
      this.articles = [];
      this.page = 0;

      this.$nextTick(() => {
        this.$refs.infiniteLoading.$emit("$InfiniteLoading:reset");
      });
    },
    resolveArticleStatus(status = "draft") {
      const statusMap = {
        draft: 1,
        toBeApproved: 2,
        toBePublished: 3,
        published: 4,
        all: ""
      };
      return statusMap[status];
    },
    resolveArticleType(type = "news") {
      const typeMap = {
        news: 1,
        activities: 2,
        privileges: 3
      };
      return typeMap[type];
    },
    getArticlesStatus(type, searchText) {
      const vm = this;
      axios
        .get(`${process.env.HOST}/api/admin/articles/statuses`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: {
            type: this.resolveArticleType(type),
            searchText
          }
        })
        .then(res => {
          if (res.data) {
            vm.$emit("statusCount", res.data);
          }
        })
        .catch(e => {
          throw e;
        });
    },
    getArticles(
      type = "news",
      status = "draft",
      searchText = "",
      page = 0,
      $state = undefined
    ) {
      const vm = this;
      axios
        .get(`${process.env.HOST}/api/admin/articles`, {
          headers: {
            Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
          },
          params: {
            page,
            limit: this.limit,
            type: this.resolveArticleType(type),
            status: this.resolveArticleStatus(status),
            searchText
          }
        })
        .then(res => {
          if (res.data.rows.length) {
            this.page = this.page + 1;
            $state.loaded();
            const articles = res.data.rows;

            articles.forEach((val, index) => {
              if (val.cover) {
                axios
                  .get(`${process.env.HOST}/api/downloads/image`, {
                    params: {
                      imageKey: val.cover
                    }
                  })
                  .then(res2 => {
                    articles[index].coverUrl = res2.data.url;
                    this.$forceUpdate();
                  })
                  .catch(e2 => {
                    $state.complete();
                    throw e2;
                  });
              }
              vm.articles = vm.articles.concat(articles);
              vm.articles = vm.cleanDuplicateArticles(vm.articles);
              return true;
            });
          } else {
            $state.complete();
          }
        })
        .catch(e => {
          $state.complete();
          throw e;
        });
    },
    editArticle(articleId) {
      this.$router.push({ name: "ArticleDetail", params: { articleId } });
    },
    confirm(action) {
      this.dialogConfirm = false;
      if (action && this.deleteArticle) {
        const vm = this;
        axios
          .delete(
            `${process.env.HOST}/api/admin/articles/${this.deleteArticle}`,
            {
              headers: {
                Authorization: `Bearer ${getCookie(Auth.AccessToken)}`
              }
            }
          )
          .then(res => {
            if (res.status === 200) {
              const index = vm.articles.findIndex(
                article => article.articlesId === vm.deleteArticle
              );
              vm.articles.splice(index, 1);
              vm.deleteArticle = "";
              vm.getArticlesStatus();
            }
          })
          .catch(e => {
            throw e;
          });
      }
    },
    showDialog(action, articleId) {
      this.deleteArticle = articleId;
      this.dialogConfirm = action;
    },
    checkTimeStage(article) {
      if (article.deletedAt) {
        return `${this.$t("feature.article.stage.delete")}${this.$t(
          "time_at"
        )} ${moment(article.deletedAt).fromNow()}`;
      } else if (article.approvedAt) {
        if (moment(article.publishedAt).diff(moment(), "m") < 0) {
          return `${this.$t("feature.article.stage.publish")}${this.$t(
            "time_at"
          )} ${moment(article.publishedAt).fromNow()}`;
        }
        return `${this.$t("feature.article.stage.approve")}${this.$t(
          "time_at"
        )} ${moment(article.approvedAt).fromNow()}`;
      } else if (article.requestedAt) {
        return `${this.$t("feature.article.stage.request")}${this.$t(
          "time_at"
        )} ${moment(article.requestedAt).fromNow()}`;
      } else if (article.updatedBy) {
        return `${this.$t("feature.article.stage.update")}${this.$t(
          "time_at"
        )} ${moment(article.updatedAt).fromNow()}`;
      }
      return `${this.$t("feature.article.stage.create")}${this.$t(
        "time_at"
      )} ${moment(article.createdAt).fromNow()}`;
    },
    checkActionStage(article) {
      if (article.deletedAt) {
        return `${this.$t("action_by")} ${article.deletedBy.firstName}`;
      } else if (article.approvedAt) {
        return `${this.$t("action_by")} ${article.approvedBy.firstName}`;
      } else if (article.requestedAt) {
        return `${this.$t("action_by")} ${article.requestedBy.firstName}`;
      } else if (article.updatedBy) {
        return `${this.$t("action_by")} ${article.updatedBy.firstName}`;
      }
      return "";
    },
    showListAttendanceButton(article) {
      if (
        this.type !== "news" &&
        article.approvedAt &&
        moment(article.publishedAt).diff(moment(), "m") < 0
      ) {
        return true;
      }
      return false;
    },
    checkDeleteRole() {
      if (
        this.status === "draft" ||
        this.status === "toBeApproved" ||
        localStorage.getItem("adminRole") <= 2
      ) {
        return true;
      }
      return false;
    },
    cleanDuplicateArticles(arr) {
      const cleaned = [];
      arr.forEach(itm => {
        let unique = true;
        cleaned.forEach(itm2 => {
          if (itm.articlesId === itm2.articlesId) unique = false;
        });
        if (unique) cleaned.push(itm);
      });
      return cleaned;
    }
  }
};
</script>

<style lang="scss" scoped>
.list-content {
  background-color: $white;
  flex-flow: column nowrap;
  align-items: stretch;
  height: calc(100% - 72px);
}
.article-wrapper {
  &.create-wrapper {
    padding: 16px 24px 16px 32px;
    flex-grow: 0;
  }
  &.content-wrapper {
    overflow: auto;
    flex-grow: 1;
    flex-basis: 0;

    ul {
      padding: 0;
      height: min-content;
    }
    .news {
      padding: 16px 24px 16px 32px;
      border-top: 1px solid #e0e0e0;

      &:last-of-type {
        border-bottom: 1px solid #e0e0e0;
      }
      &-title {
        font-size: 16px;
        font-weight: bold;
        line-height: 1.38;
        letter-spacing: -0.1px;
        color: $black;
      }
      &-detail {
        font-size: 14px;
        font-weight: 500;
        line-height: normal;
        letter-spacing: normal;
        color: #616161;
        max-height: 55px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: break-word;
      }
      &-footer {
        font-size: 12px;
        line-height: 1.5;
        letter-spacing: -0.1px;
        color: #616161;
      }
      &-time {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.1px;
        opacity: 0.5;

        &-expired {
          opacity: 1;
          color: red;
        }
      }
      &-content {
        padding-left: 32px;
      }
      .image-wrapper {
        height: 96px;
        width: 186px;
        text-align: center;
        border-radius: 5px;
        background-color: #f9f9f9;
      }
      .cover {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 5px;
        background-color: #e0e0e0;
      }
    }
  }
}
.btn-sc-create-article {
  border-radius: 5px;
  border: solid 1px #e0e0e0;
  width: 100%;
  color: $orange;
  background-color: transparent;

  &:hover,
  &:active,
  &:focus {
    border-color: $orange;
  }
  img {
    margin-right: 5px;
  }
  span {
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 30px;
    letter-spacing: -0.1px;
    vertical-align: middle;
  }
}
.article-list-button {
  display: inline-block;
  height: 32px;
  min-width: 32px;
  border-radius: 10em;
  border: 1px solid #e0e0e0;
  text-align: center;
  margin-left: 10px;

  a {
    font-size: 14px;
    font-weight: bold;
    line-height: 1.29;
    letter-spacing: -0.1px;
    color: $black;
    padding: 3px 20px;
  }
}
.no-thumbnail {
  font-size: 12px;

  color: darken(red, 6);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/view/article/list/ListContent.vue